import * as React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import type { EsgBoxConfig } from "@/types/organization";

const EMPTY_CONFIG: EsgBoxConfig[] = [];

export const useEsgPortalConfig = () => {
  const userData = useAuthenticatedUser();
  return userData.organization.esgPortalConfig ?? EMPTY_CONFIG;
};

export const useEsgBoxScope = (boxId: string) => {
  const boxes = useEsgPortalConfig();

  return React.useMemo(() => {
    const box = boxes.find(b => b.id === boxId);
    if (!box || !box.folderId) return null;

    return {
      folderId: box.folderId,
      label: box.label,
    };
  }, [boxId, boxes]);
};
